<template>
<div class="text-center">
    <v-card>
        <v-data-table v-model="selected" :headers="headers" :items="value" item-key="name" :items-per-page="3" hide-default-header hide-default-footer disable-sort>
            <template v-slot:header="{ props }">
                <thead>
                    <tr>
                        <th class="text-center" v-for="h in headers" :key="h.text">
                            <span>
                                <span>{{ h.text }}</span>
                                <v-tooltip bottom v-if="h.tooltip">
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="ml-1" small v-on="on">help</v-icon>
                                    </template>
                                    <span>{{ h.tooltip }}</span>
                                </v-tooltip>
                            </span>
                        </th>
                    </tr>
                </thead>
            </template>
            <template v-slot:body="{ items }">
                <tbody>
                    <tr v-for="item in items" :key="item.code">
                        <td :style="`color: ${colors[item.name]}`">
                            <b>{{ item.name }}</b>
                        </td>
                        <td>{{ item.initial }}</td>
                        <td>{{ item.final }}</td>
                        <td>{{ item.cagr }}</td>
                        <td>{{ item.stdev }}</td>
                        <td>{{ item.best }}</td>
                        <td>{{ item.worst }}</td>
                        <td>{{ item.mdd }}</td>
                        <td>{{ item.sharpe }}</td>
                        <td>{{ item.sortino }}</td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
    </v-card>
</div>
</template>

<script>
export default {
    name: 'return-table',
    props: [
        'value'
    ],
    data() {
        return {
            selected: [],
            colors: {
                '내 자산': '#f87979',
                'KOSPI': '#accbfc',
                'KOSDAQ': '#80eb34',
            },
            headers: [{
                    text: '구 분',
                    value: 'name',
                    align: 'center'
                },
                {
                    text: '초기 자본 [원]',
                    value: 'initial',
                    align: 'center'
                },
                {
                    text: '최종 자본 [원]',
                    value: 'final',
                    align: 'center'
                },
                {
                    text: '연이율 (CAGR)',
                    value: 'cagr',
                    align: 'center',
                    tooltip: '투자기간 내 복리수익률'
                },
                {
                    text: '표준편차 (Stdev)',
                    value: 'stdev',
                    align: 'center',
                    tooltip: '연 수익률의 변동성'
                },
                {
                    text: '최고의 해 (Best year)',
                    value: 'best',
                    align: 'center',
                    tooltip: '가장 수익이 큰 해의 수익률'
                },
                {
                    text: '최악의 해 (Worst year)',
                    value: 'worst',
                    align: 'center',
                    tooltip: '가장 수익이 적은 해의 수익률'
                },
                {
                    text: '최대 손실폭 (MDD)',
                    value: 'mdd',
                    align: 'center',
                    tooltip: '손실 중 가장 큰 값'
                },
                {
                    text: 'Sharpe ratio',
                    value: 'sharpe',
                    align: 'center',
                    tooltip: '표준편차 대비 수익률로 값이 클수록 변동성 대비 수익이 우수함을 의미'
                },
                {
                    text: 'Sortino ratio',
                    value: 'sortino',
                    align: 'center',
                    tooltip: '손실이 난 해의 표준편차 대비 수익률로 값이 클수록 손실변동성 대비 수익이 우수함을 의미'
                },
            ],
        }
    },
    watch: {
        value: function(val) {
            this.selected = this.value
        },
        selected: function (val) {
            this.$emit('select', val)
        }
    },
    methods: {}
}
</script>
